import React from "react"

interface FilterSortDrawerFooterProps {
  handleClearFilters: () => void
  resultCount?: number
}

export function FilterSortDrawerFooter({
  handleClearFilters,
  resultCount,
}: FilterSortDrawerFooterProps) {
  const handleCloseDrawer = () => {
    const drawer = document.getElementById("filter-sort-drawer")

    if (drawer) {
      drawer.classList.remove("open", "active")
      drawer.setAttribute("aria-hidden", "true")

      document.body.classList.remove("open-cc")
    }
  }

  const handleFilterClear = () => {
    handleClearFilters()
    handleCloseDrawer()
  }

  return (
    <div className="filter-sort-drawer--footer-container">
      <button
        className="filter-sort-drawer--footer-clear button medium outline"
        onClick={handleFilterClear}
      >
        Clear
      </button>
      <button
        onClick={handleCloseDrawer}
        className="filter-sort-drawer--footer-view button medium"
      >
        View {resultCount ?? 24} Results
      </button>
    </div>
  )
}
